import { render, staticRenderFns } from "./phase-aliases.vue?vue&type=template&id=41a1acfa&scoped=true&"
import script from "./phase-aliases.vue?vue&type=script&lang=ts&"
export * from "./phase-aliases.vue?vue&type=script&lang=ts&"
import style0 from "./phase-aliases.vue?vue&type=style&index=0&id=41a1acfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a1acfa",
  null
  
)

export default component.exports